import { render } from "./InformationVariant.vue?vue&type=template&id=3eb69cc8"
import script from "./InformationVariant.vue?vue&type=script&lang=js"
export * from "./InformationVariant.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__